import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowDownToLine, ArrowUpFromLine } from 'lucide-react';
import { companyLabel, empresaUrl } from '../client360/c360Shared';

const NOT_LINK = ['primeira_contratacao', 'renovacao', 'outra'];

const Bars = ({ rows, tone, testId }) => {
  const max = Math.max(1, ...rows.map((r) => r.n));
  if (!rows.length) return <div className="text-sm text-slate-400 py-4">Sem movimentos.</div>;
  return (
    <div className="space-y-1.5" data-testid={testId}>
      {rows.map((r) => (
        <div key={r.company} className="flex items-center gap-2 text-sm">
          <span className="w-40 truncate">
            {NOT_LINK.includes(r.company) ? companyLabel(r.company) : <Link to={empresaUrl(r.company)} className="hover:underline">{companyLabel(r.company)}</Link>}
          </span>
          <div className="flex-1 h-2.5 rounded-full bg-slate-100 overflow-hidden"><div className={`h-full rounded-full ${tone}`} style={{ width: `${(100 * r.n) / max}%` }} /></div>
          <b className="w-8 text-right">{r.n}</b>
        </div>
      ))}
    </div>
  );
};

export const FlowCard = ({ ganhos, perdidos, nome }) => {
  const [per, setPer] = useState('mes');
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-4" data-testid="emp360-flow">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex-1 min-w-[240px]">
          <h2 className="text-base md:text-lg font-bold font-[Outfit] text-[#2D3E6F]">Ganhos e perdidos</h2>
          <p className="text-xs text-slate-500">De onde vieram os clientes que passaram para a {nome} e para onde foram os que saíram.</p>
        </div>
        {[['mes', 'Este mês'], ['sempre', 'Desde sempre']].map(([k, l]) => (
          <button key={k} onClick={() => setPer(k)} data-testid={`emp360-flow-${k}`}
            className={`text-xs px-3 py-1 rounded-full border transition-colors ${per === k ? 'bg-[#2D3E6F] text-white border-[#2D3E6F]' : 'border-slate-200 hover:border-[#4DD4E8]'}`}>{l}</button>
        ))}
      </div>
      <div className="grid gap-6 md:grid-cols-2">
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm font-semibold text-emerald-700"><ArrowDownToLine className="w-4 h-4" />Ganhos: vieram de…</div>
          <Bars rows={ganhos[per]} tone="bg-emerald-500" testId="emp360-ganhos" />
        </div>
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm font-semibold text-rose-700"><ArrowUpFromLine className="w-4 h-4" />Perdidos: foram para…</div>
          <Bars rows={perdidos[per]} tone="bg-rose-500" testId="emp360-perdidos" />
        </div>
      </div>
    </div>
  );
};
